import { StoreServiceSite } from '../../hooks/types'

export type AvailableDatesRequest = {
  dealerId: string
  serviceOptions: string | undefined
  appointmentType: string
}

export type AvailableTimeSlotRequest = {
  dealerId: string
  appointmentTypeId: number
  date: string
}

export type AvailableTimeSlotsResponse = {
  id: number
  timeSlots: TimeSlotValue[]
}

export type TimeSlotValue = {
  description: string
  timeIn: string
}

export enum ServiceOption {
  MOT = 'MOT',
  OILFILTER = 'Oil & filter',
  STANDARD = 'Standard service',
  MAJOR = 'Major service',
}

enum AppointmentType {
  DROPGO = 'drop-go',
  DROPWAIT = 'drop-wait',
}

export type AvailableDatesResponse = {
  id: number
  appointmentType: AppointmentType
  datesAvailable: string[]
}[]

export type SendServicingEnquiryRequest = {
  customer: {
    firstName: string
    lastName: string
    email: string
    phoneNumber: string
    postcode: string
    contactTimePreference: string
  }
  enquiry: {
    storeName: string
    storeId: string
    serviceOptions: string[]
    appointmentType: string
    preferredDate?: string
    preferredTime?: string
    notes?: string
  }
  vehicle: {
    make: string
    model: string
    vrm: string
    vin: string
    fuelType: string
  }
  marketingPreferences?: {
    phone?: boolean
    email?: boolean
    sms?: boolean
  }
  campaignId?: string
}

export type GetSitesResponse = {
  sites: StoreServiceSite[]
  total: number
}
